import { http } from 'globalState/global-state.js';

export const updateCartCarNumber = params => {
    return http.xmlUnsafeRequest.get('/cart/order/api/number/', {
        params,
    });
};

export const getDeliveryList = params => {
    return http.xmlUnsafeRequest.get('/cart/order/api/deliveryList/', {
        params,
    });
};
